export default "__VITE_ASSET__BZaEbg5i__"